import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Power0 } from 'gsap/all';
import ScrollMagic from 'scrollmagic';
import {spanWrapAllLetters} from '../../helpers/texthelper';
//import {PopInBodyScrollEffect} from '../anim8.effect.scroll.text-popin-section';
export default class Anim8_casestudies {


	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR NEWS NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;
		this.useScrollTrigger = true;

		this.domElem = domElem;

		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
		this.sceneDuration = this.domElem.getAttribute('data-duration');
		this.sceneOffset = this.domElem.getAttribute('data-offset');
		this.dimensions = domElem.getBoundingClientRect();
		this.domCards = domElem.querySelectorAll('.e-loop-item');

		if( !this.domCards ||  this.domCards.length < 0 ) {
			console.error('DOM CARD CASE STUDIES NOT FOUND');
			return;
		}

		//this.setTextLetters();

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			this.defaultTween();
		}

		console.warn("[Anim8_casestudies.js] loaded");

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 1,
			defaults: {
				//ease: "power1.inOut"
				ease: 'sine'
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_casestudies.js finished");
			},
		})
		.fromTo(
			this.domCards, 
			{
				//y: ((document.body.classList.contains('single-work') === true) || (document.body.classList.contains('page-disruption') === true )) ? `25%` : `25%`,
				//webkitFilter: 'blur(10px)',
				autoAlpha: 1,
				//scale: .25,
			},
			{
				//y: `0%`,
				//webkitFilter: 'blur(0px)',
				autoAlpha: 1,
			   //scale: 1,
				//ease: Power0.easeInOut,
				//ease: Power0.easeOut,
				ease: 'none',
				delay: function(index, target, targets) {
					return .15 * index;
				},
				//duration: 1,
				overwrite: false,
				//immediateRender: false,
				onComplete: ((e)=>{
					console.log('ALL CASE STUDIES ANIMATION COMPLETE', e);

					this.domCards.forEach((elem)=>{
						if( elem.classList.contains('animate-kensburn') ) {

						} else {
							elem.classList.add('animate-kensburn');
						}
					})
				})
			}
			//'+=.15'
		)
	}

	scrollTriggerOptions() {

		let initialised = false;

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			//start: 'top center', // when the top of the trigger hits the top of the viewport
			//end: `+=${this.dimensions.height * 1.5}`,
			start: 'top top',
			end: 'bottom 0%',
			//toggleActions: "play none none reset",
			toggleActions: 'play none reverse none',
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			//onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			onEnter: (({progress, direction, isActive}) =>{

				/** /
				if( document.body.classList.contains('single-work') || document.body.classList.contains('page-disruption') ) {

					if( initialised === false ) {

						this.animateCaseStudies();
						this.animateCaseStudiesMeta();

						initialised = true;

					}

				} else {

					this.animateCaseStudies();
					this.animateCaseStudiesMeta();
				}
				/**/

				

				/** /
				if( this.domElem.querySelector('.text-wrapper') ) {
					if( initialised === false ) {
						
						this.animatedText = new PopInBodyScrollEffect(this.domElem.querySelector('.text-wrapper'));
						this.animatedText.play();
						initialised = true;

						this.animatedText.textElement.addEventListener( 'animationComplete', (e)=>{
							console.info('BlurScrollEffect Complete CaseStudies');
							//this.playCaseStudiesIntro();
							//this.defaultTween();
						});
					} else {
						this.animatedText.play();
					}
				}
				/**/
			}),
		}

	}

	initScrollMagic(scroll, sceneFactory, controller) {
	
		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: this.sceneDuration,
			//offset:  this.dimensions.height/.75,
			offset: this.sceneOffset,
			triggerHook: 'onEnter'
		})
		.setTween(this.defaultTween())
		.addTo(controller)
		.setClassToggle( this.domElem, 'active')
		

		scroll.options.scenes.push(this.scrollMagicScene);
	}

	setTextLetters() {
		const letters = this.domElem.querySelectorAll('.text-wrapper .letters');
		if( letters ) {
			letters.forEach((lettContainer)=>{
				spanWrapAllLetters(lettContainer);
			})
			//this.domLetters = spanWrapAllLetters(letters);
		}
	}

	animateVisuals() {

		const thumbnails = gsap.utils.toArray(this.domElem.querySelectorAll('.e-loop-item .grid-case-study-thumbnail .elementor-widget-theme-post-featured-image .elementor-widget-container'));

		/**/
		ScrollTrigger.create({
			trigger: '.grid-case-studies',
			start: 'top top',
			endTrigger: '#container-pirates-homepage',
			end: 'bottom 50%+=100px',
			onToggle: (self) => console.log('toggled, isActive:', self.isActive),
			onUpdate: (self) => {
				console.log(
					'progress:',
					self.progress.toFixed(3),
					'direction:',
					self.direction,
					'velocity',
					self.getVelocity()
				);
			}
		});
	}

	playCaseStudiesIntro() {

		const thumbnails = gsap.utils.toArray(this.domElem.querySelectorAll('.e-loop-item .grid-case-study-thumbnail .elementor-widget-theme-post-featured-image .elementor-widget-container'));

		gsap
		.fromTo(
			this.domCards, 
			{
				y: `-25%`,
				webkitFilter: 'blur(10px)',
				autoAlpha: 0,
				//scale: .25,
			},
			{
				y: `0%`,
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
			   //scale: 1,
				//ease: Power0.easeInOut,
				ease: Power0.easeOut,
				delay: function(index, target, targets) {
					return .3 * index;
				},
				overwrite: false,
				onComplete: ((e)=>{
					console.log('ALL CASE STUDIES ANIMATION COMPLETE', e);

					this.domCards.forEach((elem)=>{
						if( elem.classList.contains('animate-kensburn') ) {

						} else {
							elem.classList.add('animate-kensburn');
						}
					})
				})
			},
			'+=.5'
		);

		gsap
		.fromTo(
			this.domElem.querySelectorAll('.casestudy-meta'), 
			{
				y: `-10%`,
				autoAlpha: 0,
			},
			{
				y: `0%`,
				autoAlpha: 1,
				ease: Power0.easeInOut,
				stagger: .1,
				overwrite: false,
			},
			'-=.75'
		);

		gsap
		.fromTo(
			thumbnails, 
			{
				y: `-1%`,
				scale: 1.1
			},
			{
				y: `2%`,
				scale: 1,
				ease: Power0.easeInOut,
				//stagger: .1,
				overwrite: false,
				//duration: 1.3,
				delay: function(index, target, targets) {
					return .1 * index;
				},
				//immediateRender: false,
			}
		);

		gsap
		.fromTo(
			this.domElem.querySelector('.custom-call-to-action'), 
			{
				webkitFilter: 'blur(20px)',
				autoAlpha: 0,
				scale: 1.2,
			},
			{
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				overwrite: false,
				//immediateRender: false,
				ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			'-=.75'
		);

	}

	animateCaseStudies() {

		gsap.fromTo(
			this.domCards, 
			{
				y: ((document.body.classList.contains('single-work') === true) || (document.body.classList.contains('page-disruption') === true )) ? `25%` : `-25%`,
				//webkitFilter: 'blur(10px)',
				autoAlpha: 0,
				//scale: .25,
			},
			{
				y: `0%`,
				//webkitFilter: 'blur(0px)',
				autoAlpha: 1,
			   //scale: 1,
				//ease: Power0.easeInOut,
				//ease: Power0.easeOut,
				ease: 'none',
				delay: function(index, target, targets) {
					return .15 * index;
				},
				//duration: 1,
				overwrite: false,
				//immediateRender: false,
				onComplete: ((e)=>{
					console.log('ALL CASE STUDIES ANIMATION COMPLETE', e);

					this.domCards.forEach((elem)=>{
						if( elem.classList.contains('animate-kensburn') ) {

						} else {
							elem.classList.add('animate-kensburn');
						}
					})
				})
			}
			//'+=.15'
		)
	}

	animateCaseStudiesMeta() {

		gsap.fromTo(
			this.domElem.querySelectorAll('.casestudy-meta'), 
			{
				//y: (document.body.classList.contains('single-work') === true ) ? `10%` : `-10%`,
				y: ((document.body.classList.contains('single-work') === true) || (document.body.classList.contains('page-disruption') === true )) ? `10%` : `-10%`,
				autoAlpha: 0,
			},
			{
				y: `0%`,
				autoAlpha: 1,
				//ease: Power0.easeInOut,
				ease: 'none',
				stagger: .1,
				overwrite: false,
				//immediateRender: false,
			}
		)
	}

	defaultTween() {

		//this.animateVisuals();
		const thumbnails = gsap.utils.toArray(this.domElem.querySelectorAll('.e-loop-item .grid-case-study-thumbnail .elementor-widget-theme-post-featured-image .elementor-widget-container'));

		//const chars = this.domElem.querySelectorAll('.letter');
		//const charsTotal = chars.length;
		return this.timeline
		/** /
		.fromTo(
			this.domCards, 
			{
				y: `-25%`,
				webkitFilter: 'blur(10px)',
				autoAlpha: 0,
				//scale: .25,
			},
			{
				y: `0%`,
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
			   //scale: 1,
				//ease: Power0.easeInOut,
				ease: Power0.easeOut,
				delay: function(index, target, targets) {
					return .3 * index;
				},
				//duration: 1,
				overwrite: false,
				//immediateRender: false,
				onComplete: ((e)=>{
					console.log('ALL CASE STUDIES ANIMATION COMPLETE', e);

					this.domCards.forEach((elem)=>{
						if( elem.classList.contains('animate-kensburn') ) {

						} else {
							elem.classList.add('animate-kensburn');
						}
					})
				})
			},
			'+=.75'
		)
		.fromTo(
			this.domElem.querySelectorAll('.casestudy-meta'), 
			{
				y: `-10%`,
				autoAlpha: 0,
			},
			{
				y: `0%`,
				autoAlpha: 1,
				ease: Power0.easeInOut,
				stagger: .1,
				overwrite: false,
				//immediateRender: false,
			},
			'-=.75'
		)
		/**/
		.fromTo(
			thumbnails, 
			{
				y: `-1%`,
				scale: 1.1
			},
			{
				y: `2%`,
				scale: 1,
				ease: Power0.easeInOut,
				//stagger: .1,
				overwrite: false,
				//duration: 1.3,
				delay: function(index, target, targets) {
					return .1 * index;
				},
				//immediateRender: false,
			}
		)
		
	}


}
